/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  HTTPValidationError,
  Judge0Request,
  Judge0Response,
} from '../models/index';
import {
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    Judge0RequestFromJSON,
    Judge0RequestToJSON,
    Judge0ResponseFromJSON,
    Judge0ResponseToJSON,
} from '../models/index';

export interface CppRequest {
    judge0Request: Judge0Request;
}

export interface PythonRequest {
    judge0Request: Judge0Request;
}

/**
 * 
 */
export class Judge0Api extends runtime.BaseAPI {

    /**
     * Cpp
     */
    async cppRaw(requestParameters: CppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Judge0Response>> {
        if (requestParameters['judge0Request'] == null) {
            throw new runtime.RequiredError(
                'judge0Request',
                'Required parameter "judge0Request" was null or undefined when calling cpp().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/judge0/cpp`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: Judge0RequestToJSON(requestParameters['judge0Request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Judge0ResponseFromJSON(jsonValue));
    }

    /**
     * Cpp
     */
    async cpp(requestParameters: CppRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Judge0Response> {
        const response = await this.cppRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Python
     */
    async pythonRaw(requestParameters: PythonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Judge0Response>> {
        if (requestParameters['judge0Request'] == null) {
            throw new runtime.RequiredError(
                'judge0Request',
                'Required parameter "judge0Request" was null or undefined when calling python().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request({
            path: `/judge0/python`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: Judge0RequestToJSON(requestParameters['judge0Request']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Judge0ResponseFromJSON(jsonValue));
    }

    /**
     * Python
     */
    async python(requestParameters: PythonRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Judge0Response> {
        const response = await this.pythonRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
